import { render, staticRenderFns } from "./succession-file-form.vue?vue&type=template&id=25ed0f36&"
import script from "./succession-file-form.vue?vue&type=script&lang=js&"
export * from "./succession-file-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports